import { omitBy, isNil } from 'lodash/fp'
import api from '@/services/api'

const RESOURCE_URI = '/report'

const fetchOperationsReport = ({
  checkoutId,
  types,
  subTypes,
  paymentTypes,
  date
} = {}) => {
  const query = new URLSearchParams({
    types,
    subTypes,
    paymentTypes,
    date
  }).toString()

  return api.get([`${RESOURCE_URI}/${checkoutId}/operations`, query].join('?'))
}

const fetchCheckoutReport = (checkoutId) =>
  api.get(`${RESOURCE_URI}/${checkoutId}/total`)

const fetchRentsReport = ({
  storeId,
  fromDate,
  toDate,
  page,
  limit = 100,
  status
} = {}) => {
  const normalizedStatus =
    Array.isArray(status) && status.length
      ? status.join(',')
      : typeof status === 'string' && status.trim() !== ''
      ? status.trim()
      : undefined

  const base = omitBy(isNil, {
    storeId,
    fromDate,
    toDate,
    page,
    limit,
    status: normalizedStatus
  })
  const query = new URLSearchParams(base).toString()

  return api.get([`${RESOURCE_URI}/rent`, query].join('?'))
}

const fetchAdminRentsReport = ({
  storeId,
  storeIds,
  storeFilterMode,
  status,
  customer,
  toyId,
  toyIds,
  periodId,
  periodIds,
  userId,
  createdFrom,
  createdTo,
  endedFrom,
  endedTo,
  includeRanking,
  page,
  limit = 50
} = {}) => {
  const normalizedStatus =
    Array.isArray(status) && status.length
      ? status.join(',')
      : typeof status === 'string' && status.trim() !== ''
      ? status.trim()
      : undefined

  const query = new URLSearchParams(
    omitBy(isNil, {
      storeId,
      storeIds:
        Array.isArray(storeIds) && storeIds.length
          ? storeIds.join(',')
          : undefined,
      storeFilterMode,
      status: normalizedStatus,
      customer,
      toyId,
      toyIds:
        Array.isArray(toyIds) && toyIds.length ? toyIds.join(',') : undefined,
      periodId,
      periodIds:
        Array.isArray(periodIds) && periodIds.length
          ? periodIds.join(',')
          : undefined,
      userId,
      createdFrom,
      createdTo,
      endedFrom,
      endedTo,
      includeRanking,
      page,
      limit
    })
  ).toString()

  return api.get([`${RESOURCE_URI}/admin/rents`, query].join('?'))
}

const fetchProductPaymentsReport = ({ storeId, fromDate, toDate } = {}) => {
  const query = new URLSearchParams(
    omitBy(isNil, { storeId, fromDate, toDate })
  ).toString()

  return api.get([`${RESOURCE_URI}/product`, query].join('?'))
}

const fetchPaymentMethodsReport = ({ storeId, fromDate, toDate } = {}) => {
  const query = new URLSearchParams(
    omitBy(isNil, { storeId, fromDate, toDate })
  ).toString()

  return api.get([`${RESOURCE_URI}/paymentByMethods`, query].join('?'))
}

const fetchCommissionsReport = ({ storeId, fromDate, toDate } = {}) => {
  const payload = omitBy(isNil, { storeId, fromDate, toDate })

  return api.post(`${RESOURCE_URI}/commissions`, payload)
}

const fetchRentsPerToyReport = ({ storeId, fromDate, toDate } = {}) => {
  const query = new URLSearchParams(
    omitBy(isNil, { storeId, fromDate, toDate })
  ).toString()

  return api.get([`${RESOURCE_URI}/toyRents`, query].join('?'))
}

const fetchRentsPerUserReport = ({ storeId, fromDate, toDate } = {}) => {
  const query = new URLSearchParams(
    omitBy(isNil, { storeId, fromDate, toDate })
  ).toString()

  return api.get([`${RESOURCE_URI}/rentsByUser`, query].join('?'))
}

const fetchPaymentsReport = ({ storeId, fromDate, toDate, status } = {}) => {
  const query = new URLSearchParams(
    omitBy(isNil, { storeId, fromDate, toDate, status })
  ).toString()

  return api.get([`${RESOURCE_URI}/payments`, query].join('?'))
}

const fetchPeriodsReport = async ({
  storeId,
  fromDate,
  toDate,
  groupBy = 'day'
} = {}) => {
  const query = new URLSearchParams(
    omitBy(isNil, { storeId, fromDate, toDate, groupBy })
  ).toString()

  const url = `${RESOURCE_URI}/periodRents${query ? `?${query}` : ''}`
  const result = await api.get(url)
  console.log('fetchPeriodsReport result:', result)
  return result
}

export const fetchSalesPerProductReport = async ({
  storeId,
  fromDate,
  toDate
} = {}) => {
  const query = new URLSearchParams(
    omitBy(isNil, { storeId, fromDate, toDate })
  ).toString()

  const response = await api.get(`${RESOURCE_URI}/sales-per-product?${query}`)
  return response
}
export function fetchRefreshCheckoutCache(storeId) {
  return api.post(`/checkout/${storeId}/refresh`, null, {
    timeout: 15000
  })
}
export default {
  fetchPeriodsReport,
  fetchOperationsReport,
  fetchCheckoutReport,
  fetchRentsReport,
  fetchAdminRentsReport,
  fetchProductPaymentsReport,
  fetchRentsPerToyReport,
  fetchRentsPerUserReport,
  fetchPaymentMethodsReport,
  fetchPaymentsReport,
  fetchSalesPerProductReport,
  fetchCommissionsReport,
  fetchRefreshCheckoutCache
}
